const getters = {
  isMobile ({ windowWidth}) {
    return windowWidth < 700
  },
  isTablet ({ windowWidth }) {
    return windowWidth >= 700 && windowWidth < 960
  },
  isDesktop ({ windowWidth }) {
    return windowWidth >= 960
  }
}

export default getters